import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import { IFilterParameters } from './types';

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setFilterOnUsers(state, { payload }: { payload: IFilterParameters }) {
      state.isFilterOnUsers = payload;
    },
  },
});

export const { setFilterOnUsers } = usersSlice.actions;

export const usersReducer = usersSlice.reducer;
